import { UserAutocompleteItem } from "../../Layout/Models/AutocompleteItem";
import {
  UserAutocompleteSearchAction,
  UserAutocompleteSearchActionType,
  IUserAutocompleteSearchLoadedPayload,
  ISetUserAutocompleteSearchErroredPayload
} from "../Actions/UserAutocompleteSearchActions";

export interface UserAutocompleteSearchState {
  items: UserAutocompleteItem[];
  isLoaded: boolean;
  isLoading: boolean;
  isErrored: boolean;
  errorMessage: string;
  errorCode?: number;
}

const initialUserAutocompleteSearchState: UserAutocompleteSearchState = {
  items: [],
  isLoaded: false,
  isLoading: false,
  isErrored: false,
  errorMessage: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const userAutocompleteSearchReducer = (
  autocompleteSearchState: UserAutocompleteSearchState = initialUserAutocompleteSearchState,
  action: UserAutocompleteSearchAction
) => {
  switch (action.type) {
    case UserAutocompleteSearchActionType.USER_AUTOCOMPLETE_SEARCH_LOADED: {
      const payload = <IUserAutocompleteSearchLoadedPayload>action.payload;

      const { loadedItems } = payload;

      return updateObject(autocompleteSearchState, {
        items: loadedItems,
        isLoaded: true,
        isLoading: false,
        isErrored: false
      });
    }
    case UserAutocompleteSearchActionType.USER_AUTOCOMPLETE_SEARCH_UNLOAD: {
      return updateObject(autocompleteSearchState, {
        items: [],
        isLoaded: false,
        isLoading: false,
        isErrored: false
      });
    }
    case UserAutocompleteSearchActionType.USER_AUTOCOMPLETE_SEARCH_SET_LOADING: {
      return updateObject(autocompleteSearchState, {
        ...autocompleteSearchState,
        isLoaded: false,
        isLoading: true,
        isErrored: false
      });
    }
    case UserAutocompleteSearchActionType.USER_AUTOCOMPLETE_SEARCH_SET_ERRORED: {
      const payload = <ISetUserAutocompleteSearchErroredPayload>action.payload;

      return updateObject(autocompleteSearchState, {
        isErrored: true,
        errorMessage: payload.errorDescription,
        errorCode: payload.errorCode
      });
    }
    default:
      return autocompleteSearchState;
  }
};

export default userAutocompleteSearchReducer;
